import { render, staticRenderFns } from "./BannerLeftSidebar.vue?vue&type=template&id=09365a6d"
import script from "./BannerLeftSidebar.vue?vue&type=script&lang=js"
export * from "./BannerLeftSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports